module.exports = __webpack_public_path__ + "3642f8f6ea7f0d00a966d90bb441e848.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/student.png
// module id = 1712
// module chunks = 0